

















































import { Component, Vue, Watch } from 'vue-property-decorator';
import Magazine from '@/models/Magazine';
import { namespace } from 'vuex-class';

const MagazineStore = namespace('magazine');
const ApplicationStore = namespace('application');

@Component({
    components: {
        MagazineCellComponent: () => import(
            /* webpackChunkName: "MagazineCellComponent" */
            '@/components/library/MagazineCell.component.vue'),
        AccessibilityButtonComponent: () => import(
            /* webpackChunkName: "AccessibilityButtonComponent" */
            '@/components/shared/AccessibilityButton.component.vue')
    }
})
export default class LibraryComponent extends Vue {

    @MagazineStore.Getter('filteredMagazines')
    private _filteredMagazines!: Magazine[];

    @MagazineStore.Getter('paginatedMagazines')
    private _paginatedMagazines!: Magazine[];

    @MagazineStore.Getter('pagination')
    private pagination!: number | null;

    @MagazineStore.Getter('paginationIndex')
    private _paginationIndex!: number;

    get paginationIndex(): number {
        return this._paginationIndex + 1;
    }

    set paginationIndex(value: number) {
        this.applyPagination(value - 1);
    }

    @MagazineStore.Mutation('applyPagination')
    private applyPagination!: (value: number) => void;

    @MagazineStore.Getter('paginationMaxIndex')
    private paginationMaxIndex!: number;

    @ApplicationStore.Getter('accessibilityControls')
    private _accessibilityControls!: boolean;

    get accessibilityControls(): boolean {
        // they are not necessary if pagination is active
        if (this.pagination) {
            return false;
        } else {
            return this._accessibilityControls;
        }
    }

    @MagazineStore.Getter('isLoadingMagazines')
    private _isLoadingMagazines!: boolean;

    @MagazineStore.Getter('isInitialLoadingDone')
    private _isInitialLoadingDone!: boolean;

    get isInitialLoadingDone(): boolean {
        return this._isInitialLoadingDone;
    }

    get isLoadingMagazines(): boolean {
        return this._isLoadingMagazines;
    }

    get availableMagazines() {
        if (this.pagination) {
            return this._paginatedMagazines;
        } else {
            return this._filteredMagazines;
        }
    }

    public scrollBottom() {
        (this.$refs.scrollContainer as any).scrollBy({
            top: 100,
            left: 0,
            behavior: 'smooth'
        });
    }

    public scrollTop() {
        (this.$refs.scrollContainer as any).scrollBy({
            top: -100,
            left: 0,
            behavior: 'smooth'
        });
    }
};
